export const MESSAGE = {
  SERVER_ERROR: "Network Congestion.Please try again.",
};
